# Games
https://itch.io
https://mobygames.com
https://igdb.com
https://howlongtobeat.com
https://pcgamingwiki.com
https://speedrun.com
https://gog.com
https://chess.com
https://lichess.org
https://boardgamegeek.com
https://steamdb.info
https://protondb.com
https://osgameclones.com
https://dosgames.com
https://myabandonware.com
https://retrogames.cc
https://archive.org/details/softwarelibrary_msdos_games
